import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { SelectListItemModel } from 'src/app/shared/models';
import { BaseService } from '../../../services';
import { SharedModule } from '../../../shared.module';
import { LayoutService } from 'src/app/layouts/services/layout.service';
import { Subscription } from 'rxjs';

@Component({
    standalone: true,
    imports: [SharedModule],
    selector: 'app-layout-select-list',
    templateUrl: './layout-list.component.html',
    styleUrls: ['./layout-list.component.scss']
})
export class LayoutListComponent implements OnInit, OnDestroy {
    @Input() groupId: number | null = null;
    @Input() selectedLayoutId: number | null = null;
    @Output() closeDrawer = new EventEmitter<{ selectedLayout: SelectListItemModel; updateValue: boolean }>();

    model: Array<SelectListItemModel> = [];
    allLayouts: Array<SelectListItemModel> = [];
    filterKey = '';
    isLoading = true;
    isModelLoaded = false;
    hasLayouts = true;

    private subscriptions = new Array<Subscription>();

    constructor(
        private baseService: BaseService,
        private layoutService: LayoutService
    ) {}

    ngOnInit(): void {
        this.getList();
    }

    ngOnDestroy(): void {
        this.subscriptions.forEach(s => s.unsubscribe());
    }

    getList(): void {
        this.isModelLoaded = false;
        this.isLoading = true;

        const sub = this.layoutService.getSelectListItems(this.groupId).subscribe({
            next: (response: any) => {
                this.allLayouts = (response ?? []).map((item: any) => {
                    const mappedItem = new SelectListItemModel();
                    mappedItem.keyInt = item?.keyInt ?? item?.id ?? 0;
                    mappedItem.value = item?.value ?? item?.name ?? '';
                    (mappedItem as any).isSelected = this.selectedLayoutId != null && mappedItem.keyInt === this.selectedLayoutId;
                    return mappedItem;
                });
                this.hasLayouts = this.allLayouts.length > 0;
                this.applySearchFilter();
                this.isModelLoaded = true;
                this.isLoading = false;
            },
            error: (error: any) => {
                this.baseService.processErrorResponse(error);
                this.isLoading = false;
                this.isModelLoaded = true;
            }
        });
        this.subscriptions.push(sub);
    }

    private applySearchFilter(): void {
        const keyword = (this.filterKey || '').trim().toLowerCase();
        if (!keyword) {
            this.model = [...this.allLayouts];
            return;
        }

        this.model = this.allLayouts.filter(item =>
            (item.value || '').toLowerCase().includes(keyword)
        );
    }

    onSearch(): void {
        this.applySearchFilter();
    }

    clearSearch(): void {
        this.filterKey = '';
        this.applySearchFilter();
    }

    filterKeyChanged(): void {
        this.applySearchFilter();
    }

    selectLayout(item: SelectListItemModel): void {
        this.closeDrawer.emit({ selectedLayout: item, updateValue: true });
    }

    cancel(): void {
        this.closeDrawer.emit({ selectedLayout: new SelectListItemModel(), updateValue: false });
    }
}
